module.exports = __webpack_public_path__ + "static/media/loader.907b1991.svg";